import { Flex, Box } from '@chakra-ui/layout';
import {
  Table,
  Spacer,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
} from '@chakra-ui/react';
import { DatePicker, Pagination, Select } from 'antd';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';
import { SearchInput } from 'components/SearchInput';
import { usePagination } from 'hooks/use-pagination';
import { useState } from 'react';
import { useHistory } from 'react-router';
import ContractTableRow from './ContractTableRow';
import moment from 'moment';

const { RangePicker } = DatePicker;

export const ContractList = () => {
  const textColor = useColorModeValue('gray.700', 'white');
  const history = useHistory();
  const [contracts, setContracts] = useState([]);
  const [searchObj, setSearchObj] = useState({
    status: '',
    startDate: '',
    endDate: '',
  });
  const { currentPage, setQuery, total, onPageChange, setSearch } =
    usePagination('/contracts', setContracts);

  const colNames = [
    '번호',
    '주문자',
    '결제타입',
    '요청일자',
    '상태',
    '승인관리자',
  ];

  const goDetail = (id) => {
    history.push('/admin/contracts/' + id);
  };

  const onClickSearch = (searchWord) => {
    setQuery({
      ...(searchObj.status && { status: searchObj.status }),
      startDate: searchObj.startDate
        ? searchObj.startDate.format('YYYY-MM-DD')
        : null,
      endDate: searchObj.endDate
        ? searchObj.endDate.format('YYYY-MM-DD')
        : null,
      search: searchWord,
      page: 1,
    });
  };

  return (
    <>
      <Flex direction="column" pt={{ base: '120px', md: '75px' }}>
        <Card overflowX={{ sm: 'scroll', xl: 'hidden' }}>
          <CardHeader p="6px 0px 22px 0px">
            <Flex width="100%">
              <Box>
                <Text fontSize="xl" color={textColor} fontWeight="bold">
                  계약서 관리
                </Text>
              </Box>
              <Spacer></Spacer>
            </Flex>
          </CardHeader>
          <CardHeader p="6px 0px 22px 0px">
            <Box w="100%">
              <Flex mt="3px" alignItems="center">
                <Select
                  style={{ width: 120, marginRight: '5px' }}
                  onChange={(value) =>
                    setSearchObj({ ...searchObj, status: value })
                  }
                  allowClear
                  onClear={() => setSearchObj({ ...searchObj, status: '' })}
                  placeholder="상태"
                  options={[
                    { value: null, label: '전체' },
                    { value: 'READY', label: '계약서요청' },
                    { value: 'RENTAL_READY', label: '할부심사요청' },
                    { value: 'RENTAL_CHECKED', label: '할부심사완료' },
                    { value: 'UPLOADED', label: '입금대기' },
                    { value: 'MONEY_CHECKED', label: '입금확인' },
                    { value: 'SCHEDULED', label: '스케쥴확정' },
                    { value: 'FINISH', label: '완료' },
                    { value: 'DELETED', label: '삭제' },
                  ]}
                />
                <RangePicker
                  allowClear={false}
                  value={[
                    searchObj.startDate ? moment(searchObj.startDate) : '',
                    searchObj.endDate ? moment(searchObj.endDate) : '',
                  ]}
                  onChange={([start, end]) =>
                    setSearchObj({
                      ...searchObj,
                      startDate: moment(start),
                      endDate: moment(end),
                    })
                  }
                  placeholder={['검색시작일', '검색종료일']}
                />
                <SearchInput setSearch={onClickSearch}></SearchInput>
                <p style={{ marginLeft: '3px' }}>갯수: {total} 개</p>
              </Flex>
            </Box>
          </CardHeader>
          <CardBody>
            <Table variant="simple" color={textColor}>
              <Thead>
                <Tr my=".8rem" pl="0px" color="gray.400">
                  {colNames.map((colName, idx) => {
                    return (
                      <Th
                        color="gray.400"
                        key={idx}
                        ps={idx === 0 ? '0px' : null}
                      >
                        {colName}
                      </Th>
                    );
                  })}
                </Tr>
              </Thead>
              <Tbody>
                {contracts.map((row) => {
                  return (
                    <Tr key={row.id} onClick={() => goDetail(row.id)}>
                      <ContractTableRow data={row} />
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </CardBody>
          <Box mt="5">
            <Pagination
              showSizeChanger={false}
              current={currentPage}
              onChange={onPageChange}
              total={total}
            ></Pagination>
          </Box>
        </Card>
      </Flex>
    </>
  );
};
